import { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FieldsFilter, Grid, InputSearch } from 'src/components/UI'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import { jobsActions } from 'src/ducks/actions'
import { getClientData, getJobsForTable } from 'src/ducks/selectors'
import { JobItem } from 'src/ducks/types'
import headers from './headers'

const Jobs: FC = () => {
    const dispatch = useDispatch()
    const userData = useSelector(getClientData())
    const clientId = userData?.id
    const allJobs = useSelector(getJobsForTable())

    const [loading, setLoading] = useState(false)
    const [searchFilter, setSearchFilter] = useState('')
    const [tableHeaders, setTableHeaders] = useState(headers)

    const onTableFilterChange = (index: number): void => {
        setTableHeaders(tableHeaders.map((item, indx) => {
            if (indx === index) {
                return { ...item, hide: !item.hide }
            }
            return item
        }))
    }

    const fetchJobs = useCallback(() => {
        if (clientId) {
            setLoading(true)
            dispatch(
                jobsActions.fetchJobs(
                    {
                        page: 0,
                        size: 100,
                        searchParams: {
                            clientId: clientId,
                        }
                    },
                    (_succ: boolean) => {
                        setLoading(false)
                    }
                )
            )
        }
    }, [clientId, dispatch])

    useEffect(() => {
        fetchJobs()
    }, [fetchJobs])

    // Filter jobs based on search
    const filteredJobs = allJobs.filter((job: JobItem) => {
        if (!searchFilter) return true
        const searchLower = searchFilter.toLowerCase()
        return (
            job.properties.publicId?.toLowerCase().includes(searchLower) ||
            job.properties.fullAddress?.toLowerCase().includes(searchLower) ||
            job.properties.address.city?.toLowerCase().includes(searchLower)
        )
    })

    // Transform data to include needed fields
    const tableData = filteredJobs.map((job: JobItem) => ({
        ...job,
        publicId: job.properties.publicId || '-',
        fullAddress: job.properties.fullAddress || '-',
        city: job.properties.address.city || '-',
        state: job.properties?.address?.state || '-',
        zipCode: job.properties?.address?.zipCode || '-',
        territory: job.properties.territory.title || '-',
        totalValue: job.properties.totalValue ? `$${job.properties.totalValue.toFixed(2)}` : '$0.00',
    }))

    return (
        <Grid container>
            <Grid item flex={1}>
                <Grid container justifyContent="flex-end" spacing={2} marginBottom={2}>
                    <Grid item>
                        <InputSearch
                            placeholder='Search...'
                            onChange={setSearchFilter}
                            value={searchFilter}
                        />
                    </Grid>
                    <Grid item>
                        <FieldsFilter options={tableHeaders} handleChange={onTableFilterChange} />
                    </Grid>
                </Grid>
                <Table
                    headers={tableHeaders}
                    loading={loading}
                >
                    {tableData}
                </Table>
            </Grid>
        </Grid>
    )
}

export default Jobs